import React, { Component, Fragment } from 'react';
import './css/font-awesome.css';
import './index.css';
import { Route, Switch } from "react-router-dom";
import Scene from "./Scene";
import Header from "./components/Header";
import { ConnectedRouter } from 'connected-react-router'
import UnlockModal from "./components/UnlockModal";
import { ModalRoute, ModalContainer } from "react-router-modal";
import OrientationModal from "./components/OrientationModal";
import DesktopOnly from "./components/DesktopOnly";
import windowSize from 'react-window-size';
import { withLocalize } from "react-localize-redux";
import { Helmet } from "react-helmet";
import "@babel/polyfill";

import en_us from "./localization/en-us.json";
import en_gb from "./localization/en-gb.json";
import de from "./localization/de-de.json";
import fr_fr from "./localization/fr-fr.json";
import es_mx from "./localization/es-mx.json";
import ja_jp from "./localization/ja-jp.json";
import pt_br from "./localization/pt-br.json";
import zh_tw from "./localization/zh-tw.json";
import it_it from "./localization/it-it.json";
import tr_tr from "./localization/tr-tr.json";
import ko_kr from "./localization/ko-kr.json";
import ar_sa from "./localization/ar-sa.json";
import pl_pl from "./localization/pl-pl.json";
class App extends Component {

  constructor(props) {
    super(props);


    this.props.initialize({
      languages: [
        { name: "English (US)", code: "en-us" },
        { name: "German", code: "de-de" },
        { name: "English (UK)", code: "en-gb" },
        { name: "Japanese", code: "ja-jp" },
        { name: "French", code: "fr-fr" },
        { name: "Spanish", code: "es-mx" },
        { name: "Portuguese", code: "pt-br" },
        { name: "Chinese", code: "zh-tw" },
        { name: "Italian", code: "it-it" },
        { name: "Turkish", code: "tr-tr" },
        { name: "Korean", code: "ko-kr" },
        { name: "Arabic", code: "ar-sa" },
        { name: "Polish", code: "pl-pl" }
      ],
      options: {
        renderToStaticMarkup: false,
        renderInnerHtml: true
      }
    });
    this.props.addTranslationForLanguage(en_us, "en-us");
    this.props.addTranslationForLanguage(en_gb, "en-gb");
    this.props.addTranslationForLanguage(ja_jp, "ja-jp");
    this.props.addTranslationForLanguage(de, "de-de");
    this.props.addTranslationForLanguage(fr_fr, "fr-fr");
    this.props.addTranslationForLanguage(es_mx, "es-mx");
    this.props.addTranslationForLanguage(pt_br, "pt-br");
    this.props.addTranslationForLanguage(zh_tw, "zh-tw");
    this.props.addTranslationForLanguage(it_it, "it-it");
    this.props.addTranslationForLanguage(tr_tr, "tr-tr");
    this.props.addTranslationForLanguage(ko_kr, "ko-kr");
    this.props.addTranslationForLanguage(ar_sa, "ar-sa");
    this.props.addTranslationForLanguage(pl_pl, "pl-pl");

    if (window.location.href.indexOf("de-de") > -1) {
      this.props.setActiveLanguage("de-de");
    }
    else if (window.location.href.indexOf("ja-jp") > -1) {
      this.props.setActiveLanguage("ja-jp");
    }
    else if (window.location.href.indexOf("en-gb") > - 1) {
      this.props.setActiveLanguage("en-us");
    }
    else if (window.location.href.indexOf("fr-fr") > - 1) {
      this.props.setActiveLanguage("fr-fr");
    }
    else if (window.location.href.indexOf("es-mx") > - 1) {
      this.props.setActiveLanguage("es-mx");
    }
    else if (window.location.href.indexOf("pt-br") > - 1) {
      this.props.setActiveLanguage("pt-br");
    }
    else if (window.location.href.indexOf("zh-tw") > - 1) {
      this.props.setActiveLanguage("zh-tw");
    }
    else if (window.location.href.indexOf("it-it") > - 1) {
      this.props.setActiveLanguage("it-it");
    }
    else if(window.location.href.indexOf("tr-tr") > - 1) {
      this.props.setActiveLanguage("tr-tr");
    }
    else if(window.location.href.indexOf("ko-kr") > - 1) {
      this.props.setActiveLanguage("ko-kr");
    }
    else if(window.location.href.indexOf("ar-sa") > - 1) {
      this.props.setActiveLanguage("ar-sa");
    }
    else if(window.location.href.indexOf("pl-pl") > - 1) {
      this.props.setActiveLanguage("pl-pl");
    }
    else {
      this.props.setActiveLanguage("en-us");
    }
  }

  render() {

    let { history, translate, activeLanguage } = this.props;

    return (
      <div className={`app lang-${activeLanguage ? activeLanguage.code : "en-us"}`}>

        <Helmet>
          <title>{translate("pageTitle")}</title>
          <meta name="description" content={translate("pageDescription")} />
          <meta name="og:title" content={translate("openGraphTitle")} />
          <meta name="og:description" content={translate("openGraphDescription")} />
          <meta name="og:site_name" content={translate("openGraphSiteName")} />
          <meta name="og:locale" content={translate("openGraphLocale")} />
          <meta name="twitter:title" content={translate("twitterTitle")} />
          <meta name="twitter:description" content={translate("twitterDescription")} />
        </Helmet>

        {this.props.windowWidth >= 1200 ?

          (<Fragment>

            <Header />

            <ConnectedRouter history={history}>
              <div>
                <Switch>
                  <Route default exact path="/:level1" component={Scene} />
                  <Route default path="/:level1/:level2" component={Scene} />
                  <Route default path="/" component={Scene} />
                </Switch>
                <ModalRoute component={UnlockModal} path={`*/unlock`} className="unlock-modal_container react-router-modal__modal" />
                <ModalContainer />
              </div>

            </ConnectedRouter>

            <OrientationModal />
          </Fragment>)

          :

          (<DesktopOnly />)

        }

      </div>
    );
  }
}

export default withLocalize(windowSize(App));



// WEBPACK FOOTER //
// ./src/App.js